import Fuse from 'fuse.js';
import { SEARCH_CONFIG } from '@constants/config';

export function normalizeSearchIndex(data) {
  if (!data || !Array.isArray(data.episodes)) {
    throw new Error('Invalid search index');
  }

  return data;
}

export function createSearchEngine(searchIndex) {
  return new Fuse(searchIndex.episodes, SEARCH_CONFIG);
}

export function canSearch(query) {
  return typeof query === 'string' && query.trim().length >= SEARCH_CONFIG.minMatchCharLength;
}

export function searchEpisodes(searchEngine, query) {
  if (!searchEngine || !canSearch(query)) {
    return [];
  }

  return searchEngine.search(query.trim());
}

export function getSearchSnippet(fullText, query) {
  const text = fullText || '';
  const normalizedQuery = (query || '').toLowerCase();
  const matchIndex = text.toLowerCase().indexOf(normalizedQuery);

  if (matchIndex === -1) {
    return `${text.slice(0, 200)}...`;
  }

  const start = Math.max(0, matchIndex - 60);
  const end = Math.min(text.length, matchIndex + 180);
  let snippet = text.slice(start, end);

  if (start > 0) snippet = `...${snippet}`;
  if (end < text.length) snippet = `${snippet}...`;

  return snippet;
}

export function getEpisodeSearchSnippet(episode, query) {
  const searchableFields = [episode?.summary, episode?.aiSummary, episode?.fullText]
    .filter(Boolean);
  const normalizedQuery = (query || '').trim().toLowerCase();
  const matchingText = searchableFields.find((text) =>
    text.toLowerCase().includes(normalizedQuery)
  );

  return getSearchSnippet(matchingText || searchableFields.join(' '), query);
}
